import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Box, Stack, Typography } from '@mui/material';
import { DatePicker } from '../../../../../../ui/input/date_picker/date_picker';
import { assessmentTypes } from '../../../../../../utils/analytics_data/filterData';
import { RootState } from '../../../../../../utils/redux_store/store';
import { AssessmentsSearchObject } from '../../../../../../utils/types/assessment_types';
import { SelectOptions } from '../../../../../../utils/types/react_select_types';

type AssessmentFilterProps = {
  searchObject: AssessmentsSearchObject;
  setSearchObject: (searchObject: AssessmentsSearchObject) => void;
};

const AssessmentFilter: React.FC<AssessmentFilterProps> = ({
  searchObject,
  setSearchObject,
}) => {
  const skills = useSelector((state: RootState) => state.skills);
  const [assessmentList, setAssessmentList] = useState<SelectOptions[]>(
    skills.skillsList,
  );

  const handleTimeChange = (timeRange: { startDate: string | null; endDate: string | null }) => {
    setSearchObject({
      ...searchObject,
      timeRange,
    });
  };

  const handleAssessmentNameChange = (action: any, actionValues: any) => {
    setSearchObject({
      ...searchObject,
      [actionValues.name]: action
        ? action.value.charAt(0).toUpperCase() + action.value.slice(1)
        : '',
    });
  };

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      spacing={2}
      sx={{ bgcolor: 'background.paper' }}
    >
      <Box>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', display: 'block', mb: 0.5 }}>
          Time Range
        </Typography>
        <DatePicker
          startDate={searchObject.timeRange?.startDate ?? null}
          endDate={searchObject.timeRange?.endDate ?? null}
          onChange={handleTimeChange}
        />
      </Box>

      <Box sx={{ minWidth: 250, maxWidth: 400, zIndex: 30 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', display: 'block', mb: 0.5 }}>
          Assessment Type
        </Typography>
        <Select
          placeholder="Select Assessment Type"
          name="assessmentType"
          options={assessmentTypes}
          onChange={handleAssessmentNameChange}
          isClearable={true}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />
      </Box>
    </Stack>
  );
};

export default AssessmentFilter;
